import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { generateQrCode, generateQrCodeLink, getQrcodeTemplate, getTemplateResourceList } from './request';
import { structureList, accountResources } from '@/views/customer/accountManage/request';
import { downloadFileFun, clickCopy } from '@/utils/public';
// import previewModel from '@/views/insurance/releaseManage/previewFrom/previewModel.vue';
import productListPreview from '@/views/insurance/releaseManage/previewFrom/productListPreview.vue';
import { mapState, mapMutations } from 'vuex';
export default {
  components: {
    productListPreview
  },
  data() {
    return {
      customerId: '',
      structureId: undefined,
      userIds: [],
      dialogVisible: false,
      templateList: [],
      treeData: [],
      accountList: [],
      productList: [],
      dataFrom: {
        qrConfigId: undefined,
        qrConfigIds: undefined,
        productListPageId: undefined,
        structureId: undefined,
        userIds: '',
        userId: ''
      },
      btnShow: false,
      link: '',
      name: '',
      insuranceId: '',
      previewShow: false,
      customerInsuranceId: '',
      productListPreviewShow: false,
      customerName: '',
      productName: '',
      departName: ''
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    dataRule() {
      return {
        qrConfigIds: [{
          required: true,
          message: this.$t('请选二维码模版'),
          trigger: 'change'
        }],
        structureId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('部门架构')
        }],
        userIds: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('账号')
        }],
        productListPageId: [{
          required: true,
          trigger: 'change',
          validator: this.checkProductList
        }]
      };
    },
    checkProductList() {
      return (rule, value, callback) => {
        var _this$dataFrom$qrConf;
        if (((_this$dataFrom$qrConf = this.dataFrom.qrConfigIds) === null || _this$dataFrom$qrConf === void 0 ? void 0 : _this$dataFrom$qrConf.length) > 1 && !value) {
          callback(new Error(this.$t('请选择') + this.$t('产品列表模版')));
        } else {
          callback();
        }
      };
    },
    structureIdDisable() {
      var _this$dataFrom$qrConf2, _this$dataFrom$qrConf3;
      // 部门下拉框是否禁用
      if (((_this$dataFrom$qrConf2 = this.dataFrom.qrConfigIds) === null || _this$dataFrom$qrConf2 === void 0 ? void 0 : _this$dataFrom$qrConf2.length) > 1 && this.dataFrom.productListPageId != undefined) {
        return false;
      } else if (((_this$dataFrom$qrConf3 = this.dataFrom.qrConfigIds) === null || _this$dataFrom$qrConf3 === void 0 ? void 0 : _this$dataFrom$qrConf3.length) == 1) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    console.log(this.accountInfo, 'this.accountInfo');
  },
  methods: {
    ...mapMutations({
      SET_PAGE_SHOW: 'control/SET_PAGE_SHOW'
    }),
    async init() {
      if (this.accountInfo) {
        this.customerId = this.accountInfo.customerId;
        // 获取客户名称
        this.customerName = this.accountInfo.nickName;
        // 获取二维码模版
        this.getQrcodeTemplateFun();
        // 获取部门数据
        const res = await structureList({
          customerId: this.customerId
        });
        this.treeData = res;
      }
      this.dialogVisible = true;
    },
    // 获取二维码模板
    async getQrcodeTemplateFun() {
      this.dataFrom.qrConfigIds = undefined;
      this.templateList = await getQrcodeTemplate({
        customerId: this.customerId
      });
    },
    onChange() {
      this.getAccountFun();
      this.dataFrom.userIds = '';
      this.userIds = [];
      this.link = '';
    },
    // 二维码模板选择
    async qrConfigChange() {
      this.dataFrom.structureId = undefined;
      this.dataFrom.userIds = '';
      this.userIds = [];
      this.link = '';
      this.btnShow = false;
      this.customerInsuranceId = '';
      // 账户下拉框失焦
      this.dataFrom.userIds = '';
      this.$refs.accountRef.blur();
      if (this.dataFrom.qrConfigIds.length > 1) {
        this.dataFrom.productListPageId = undefined;
        this.productList = await getTemplateResourceList({
          pageType: 'PRODUCT_LIST_PAGE',
          customerId: this.customerId
        });
      } else if (this.dataFrom.qrConfigIds.length == 1) {
        this.customerInsuranceId = this.templateList.filter(item => item.id == this.dataFrom.qrConfigIds[0])[0].customerInsuranceId;
        // 获取产品名称
        this.productName = this.templateList.filter(item => item.id == this.dataFrom.qrConfigIds[0])[0].customerInsuranceName;
      } else {
        return;
      }
    },
    // 选择账号
    async accountChange() {
      this.dataFrom.userIds = this.userIds.join(',');
      if (this.userIds.length == 1) {
        this.dataFrom.userId = this.userIds.join(',');
        this.btnShow = true;
        // 生成链接
        const params = {
          customerId: this.customerId,
          customerInsuranceId: this.customerInsuranceId,
          qrConfigId: this.dataFrom.qrConfigIds.length > 1 ? undefined : this.dataFrom.qrConfigIds[0],
          structureId: this.dataFrom.structureId,
          userId: this.dataFrom.userId,
          qrConfigIds: this.dataFrom.qrConfigIds.length > 1 ? this.dataFrom.qrConfigIds.join(',') : undefined,
          productListPageId: this.dataFrom.qrConfigIds.length > 1 ? this.dataFrom.productListPageId : undefined
        };
        this.link = await generateQrCodeLink(params);
      } else if (this.userIds.length > 1) {
        this.dataFrom.userId = this.userIds.join(',');
        this.btnShow = true;
        this.link = '';
      } else {
        this.link = '';
        this.btnShow = false;
      }
    },
    // 获取部门数据
    getDepartName(arr) {
      arr.forEach(item => {
        if (item.id == this.dataFrom.structureId) {
          this.departName = item.name;
        } else {
          this.getDepartName(item.children);
        }
      });
    },
    async getAccountFun() {
      var _this$dataFrom$qrConf4;
      this.accountList = await accountResources({
        customerId: this.customerId,
        structureId: this.dataFrom.structureId
      });
      if (((_this$dataFrom$qrConf4 = this.dataFrom.qrConfigIds) === null || _this$dataFrom$qrConf4 === void 0 ? void 0 : _this$dataFrom$qrConf4.length) > 1) {
        // 获取部门名字-需要递归
        this.treeData.forEach(item => {
          if (item.id == this.dataFrom.structureId) {
            this.departName = item.name;
          } else {
            this.getDepartName(item.children);
          }
        });
      }
    },
    // 下载
    downloadFun() {
      console.log(this.dataFrom.userIds, 'this.dataFrom.userIds');
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          // if (this.dataFrom.userIds == '') {
          //   console.log(this.dataFrom.userIds, '空空空');
          //   return this.$message.error(this.$t('请选择账号'));
          // }
          if (this.userIds.length > 10) {
            return this.$message.error(this.$t('账号最多选十个'));
          }
          const params = {
            customerId: this.customerId,
            customerInsuranceId: this.customerInsuranceId,
            qrConfigId: this.dataFrom.qrConfigIds.length > 1 ? undefined : this.dataFrom.qrConfigIds[0],
            structureId: this.dataFrom.structureId,
            userIds: this.dataFrom.userIds,
            qrConfigIds: this.dataFrom.qrConfigIds.length > 1 ? this.dataFrom.qrConfigIds.join(',') : undefined,
            productListPageId: this.dataFrom.qrConfigIds.length > 1 ? this.dataFrom.productListPageId : undefined
          };
          const res = await generateQrCode(params);
          // 单条 产品名称_客户名称
          // 多条 客户名称_部门名称
          if (this.dataFrom.qrConfigIds.length > 1) {
            this.name = `${this.customerName}_${this.departName}`;
          } else {
            this.name = `${this.productName}_${this.customerName}`;
          }
          downloadFileFun(res, 'application/zip', this.name);
        }
      });
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    },
    clickCopyFun() {
      clickCopy(this.link);
    },
    previewFun() {
      this.previewShow = true;
      const arr = this.templateList.filter(item => item.id == this.dataFrom.qrConfigId);
      this.$nextTick(() => {
        this.$refs.previewRef.init(this.customerInsuranceId, this.insuranceId, arr[0].templateControlsGroupId, arr[0].linkType, arr[0].insureLink);
      });
    },
    productListPreviewFun() {
      let val = this.productList.filter(item => item.id == this.dataFrom.productListPageId)[0];
      this.productListPreviewShow = true;
      let controlsGroupConfig = JSON.parse(val.controlsGroupConfig);
      console.log(controlsGroupConfig, '-----click yulan---------');
      controlsGroupConfig.controlsConfig.map(item => {
        if (item.controlsMark == 'productList' && item.controlsObject.landingPageModuleDisplay) {
          this.SET_PAGE_SHOW(2);
        }
      });
      this.$nextTick(() => {
        this.$refs.productListPreviewRef.init(val);
      });
    }
  }
};